import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Icon } from "@/lib/icons";
import { Search } from "lucide-react";

export default function Knowledge() {
  const [cats, setCats] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/knowledge/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);

  const filtered = cats.filter((c) => c.name.toLowerCase().includes(q.toLowerCase()) || c.description.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-8" data-testid="knowledge-page">
      <div>
        <span className="font-mono-eco text-xs uppercase tracking-widest text-slate-500">Knowledge Universe</span>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-white tracking-tight mt-1">Explore every corner of business.</h1>
        <p className="text-slate-400 mt-2">{cats.length} categories, each from Beginner to Expert. Pick a topic and ECO writes the lesson.</p>
      </div>

      <div className="relative max-w-md">
        <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500" />
        <input data-testid="knowledge-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search categories…" className="eco-input pl-10" />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filtered.map((c) => (
          <Link key={c.id} to={`/knowledge/${c.id}`} data-testid={`category-${c.id}`} className="eco-card eco-card-hover p-6 group">
            <div className="h-11 w-11 rounded-xl flex items-center justify-center mb-4" style={{ background: `${c.color}1a`, border: `1px solid ${c.color}33` }}>
              <Icon name={c.icon} size={22} style={{ color: c.color }} strokeWidth={1.5} />
            </div>
            <h3 className="font-display text-lg font-semibold text-white">{c.name}</h3>
            <p className="text-sm text-slate-400 mt-1.5 line-clamp-2">{c.description}</p>
            <div className="flex gap-1.5 mt-4">
              {Object.keys(c.levels).map((lvl) => <span key={lvl} className="text-[10px] font-mono-eco uppercase tracking-wider text-slate-600">{lvl[0]}</span>)}
              <span className="text-[10px] font-mono-eco uppercase tracking-wider text-slate-600 ml-auto">{Object.values(c.levels).flat().length} topics</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
